function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STATE_DEFAULT = {};
export var DOWNLOAD_MENU_LOAD = 'DOWNLOAD_MENU_LOAD';
export var DOWNLOAD_MENU_UPDATE = 'DOWNLOAD_MENU_UPDATE';
export var DOWNLOAD_MENU_SUBMIT = 'DOWNLOAD_MENU_SUBMIT';
export var DOWNLOAD_MENU_SUBMIT_END = 'DOWNLOAD_MENU_SUBMIT_END';
export function constructDownloadMenuId(countryCode, plotId) {
  return "".concat(countryCode, "_").concat(plotId);
}
export default function downloadMenu() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case DOWNLOAD_MENU_LOAD:
      return Object.assign({}, state, _defineProperty({}, constructDownloadMenuId(action.countryCode, action.plotId), {
        loading: true
      }));

    case DOWNLOAD_MENU_UPDATE:
      return Object.assign({}, state, _defineProperty({}, constructDownloadMenuId(action.countryCode, action.plotId), {
        metadata: action.metadata,
        loading: false
      }));

    case DOWNLOAD_MENU_SUBMIT:
      return Object.assign({}, state, _defineProperty({}, constructDownloadMenuId(action.countryCode, action.plotId), Object.assign({}, state[constructDownloadMenuId(action.countryCode, action.plotId)], {
        submitting: true
      })));

    case DOWNLOAD_MENU_SUBMIT_END:
      return Object.assign({}, state, _defineProperty({}, constructDownloadMenuId(action.countryCode, action.plotId), Object.assign({}, state[constructDownloadMenuId(action.countryCode, action.plotId)], {
        submitting: false
      })));

    default:
      return state;
  }
}